module.exports = __webpack_public_path__ + "static/img/icon3.955414e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/lottery/winning/icon3.png
// module id = aQaA
// module chunks = 6